export default currentUser => permission =>
  currentUser && currentUser.permissions && currentUser.permissions.indexOf(permission) !== -1;
